( function( $ ) {
    $(".wpg-wdp-product-list-item").on('click', function(e) {
        // dont trigger the click if you are already clicking on a link
        if (!$(e.target).closest("a").length) {
            $(this).find('.wpg-wdp-product-list-item-title-link').trigger('click');
        }
    });
} )( jQuery );
